import { ApkResponse } from '../../api-http/apk';
import { AlertBar } from '../../components/AlertBar';
import { StyledTableCell } from '../../components/TableTheme';
import { managementTableSx } from '../../components/ManagementPageLayout';
import { PagingResponse } from '../../types';
import {
  IconButton,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
} from '@mui/material';
import React, { FC } from 'react';
import { Download } from 'react-feather';

interface ApksTableProps {
  data?: PagingResponse<ApkResponse>;
  isLoading: boolean;
  error?: any;
}

const ApkTable: FC<ApksTableProps> = ({ data, error, isLoading }) => {
  const TableRows: FC<Pick<ApksTableProps, 'data'>> = ({ data }) => {
    return (
      <>
        {data?.data?.map(({ _id, name, version, key }) => (
          <TableRow key={_id}>
            <TableCell>{name}</TableCell>
            <TableCell>{version}</TableCell>
            <TableCell align="center">
              <Tooltip title={`Download ${name}`}>
                <IconButton
                  component="a"
                  href={key}
                  download
                  aria-label={`Download ${name}`}
                  sx={{
                    width: 32,
                    height: 32,
                    border: '1px solid #dbe3ee',
                    borderRadius: 2,
                    color: '#2563eb',
                  }}
                >
                  <Download size={15} />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        ))}
      </>
    );
  };

  return (
    <>
      <AlertBar severity="error" msg={error?.msg} />
      {isLoading && <LinearProgress />}
      <TableContainer component={Paper} sx={managementTableSx}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Name</StyledTableCell>
              <StyledTableCell>Version</StyledTableCell>
              <StyledTableCell align="center">Actions</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRows data={data} />
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default ApkTable;
